import cn from "classnames";
import { handleBack } from "core-lib/utils/common";
import React, { useEffect, useRef, useState } from "react";

import s from "./BackButton.module.scss";

import {
  removeClassFromList,
  setAndGetBackBtnClass,
} from "core-lib/utils/backButton";
import Icon from "../Icon/Icon";

export function BackButton({
  onBack,
  type = "default",
  children,
  className,
  customStyle,
  noPadding = false,
  domId,
}: {
  onBack?: any;
  type?:
    | "default"
    | "white"
    | "arrow"
    | "hidden"
    | "cross"
    | "chevronLeft"
    | "arrowLeft"
    | "whiteCross"
    | "arrowLeftWhite";
  children?: React.ReactNode;
  customStyle?: any;
  className?: string;
  noPadding?: boolean;
  domId?: string;
}) {
  const [didRender, setDidRender] = useState(false);
  const btnRef = useRef();
  const btnClassRef = useRef();

  useEffect(() => {
    setDidRender(true);
  }, []);

  useEffect(() => {
    if (didRender) {
      const cName = setAndGetBackBtnClass();
      // @ts-ignore
      btnClassRef.current = cName;
      // @ts-ignore
      btnRef?.current?.classList.add(cName);
    }
    return () => {
      if (btnClassRef) removeClassFromList(btnClassRef.current);
    };
  }, [didRender]);

  function onBackClick(e: any) {
    if (onBack) {
      onBack(e);
    } else {
      handleBack();
    }
  }

  // TODO: Commented for now but needs to check whether this is working
  // if (!didRender) return null;

  return (
    <button
      id={domId}
      //@ts-ignore
      ref={btnRef}
      type="button"
      className={cn("cmn_touchable_area", {
        [s.back]: type !== "hidden" && !noPadding,
        cmn_hide: type === "hidden",
        [`${className}`]: !!className,
      })}
      style={customStyle}
      onClick={onBackClick}
      aria-label="back-button"
    >
      {children && children}
      {!children && (
        <>
          {type === "default" && (
            <Icon name="ChevronLeftRegular" color="grey_white" />
          )}
          {type === "white" && (
            <Icon name="ChevronLeftRegular" color="grey_white" />
          )}
          {type === "arrow" && (
            <Icon name="ChevronLeftRegular" color="primary" />
          )}
          {type === "chevronLeft" && <Icon name="ChevronLeftRegular" />}
          {type === "whiteCross" && (
            <Icon name="CrossCircleRegular" color="on_dark_bg" />
          )}
          {type === "cross" && <Icon name="CrossCircleRegular" />}
          {type === "arrowLeft" && <Icon name="ArrowLeftRegular" />}
          {type === "arrowLeftWhite" && (
            <Icon name="ArrowLeftRegular" color="on_dark_bg" />
          )}
          {type === "hidden" && <span />}
        </>
      )}
    </button>
  );
}
